
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { Component } from '@angular/core';
import { ShoppingCartListComponent } from '../../components/shopping-cart-list/shopping-cart-list.component';

@Component({
  selector: 'cv-footer-button-rendered',
  template: `
      <!-- <div class="btn-checkout-shopping" [hidden]="showCheckoutMessage()"> -->
      <div class="" [hidden]="showCheckoutMessage()">
        <button style="margin-bottom:40px;" type="button" class="btn btn-primary" [disabled]="!enableCheckout()"
            (click)="enableCheckout() ? checkOut() : null"><span cvLocalizedText langSection="MarketPlace"
                langKey="Checkout">Checkout</span></button>
      </div>
  <!-- <button style="margin-bottom:40px;" type="button" class="btn btn-primary" [disabled]="!enableCheckout()"
  (click)="enableCheckout() ? checkOut() : null"><span cvLocalizedText langSection="MarketPlace"
  langKey="Checkout">Checkout</span></button> -->
`,
  styleUrls: ['./footer-button-rendered.component.scss']
})
export class FooterButtonRenderedComponent implements ICellRendererAngularComp {

  public params: any;

  constructor(public shoppingCartListComponent: ShoppingCartListComponent) { }
  refresh(): boolean {
    return false;
  }
  agInit(params: any): void {
    this.params = params;
  }

  enableCheckout(): boolean {
    return this.shoppingCartListComponent.enableCheckout();
  }

  checkOut(){
    this.shoppingCartListComponent.checkOut();
  }

  showCheckoutMessage(): boolean {
    return this.shoppingCartListComponent.pscs.pointStoreVisibleContent.showCheckoutMessage;
  }

}
